import { createContext, useContext, useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { endpoints } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount, ask the server who we are based on the httpOnly cookie.
  useEffect(() => {
    let cancelled = false;
    endpoints.me()
      .then((r) => { if (!cancelled) setUser(r.data.user); })
      .catch(() => { if (!cancelled) setUser(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const login = (userData) => setUser(userData);

  const logout = async () => {
    try { await endpoints.logout(); } catch (err) { console.warn("Logout request failed:", err); }
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
